module.exports = __webpack_public_path__ + "img/EN-Wix-integration-vidjet-step2.a0861bf1.png";